export const onEnterPress = onPress => ({ key }) => key === 'Enter' && onPress();
